import React from 'react';

import { Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { GridFilterModel } from '@mui/x-data-grid-pro';

import { COMPETITOR_OFFERS_PRESETS, CompetitorOffersPreset } from './constants';
import { presetOf } from './utils';

const CUSTOM = 'custom';

interface Props {
  filterModel: GridFilterModel;
  onChange: (preset: CompetitorOffersPreset) => void;
  onCustom: () => void;
}

export default function CompetitorOffersPresets({ filterModel, onChange, onCustom }: Props) {
  const preset = presetOf(filterModel);

  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Typography variant="body2" color="text.secondary" id="competitor-offers-view-label">
        View
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        color="primary"
        value={preset ?? CUSTOM}
        onChange={(_, nextPreset: CompetitorOffersPreset | typeof CUSTOM | null) =>
          nextPreset && nextPreset !== CUSTOM ? onChange(nextPreset) : onCustom()
        }
        aria-labelledby="competitor-offers-view-label"
      >
        <ToggleButton value={CUSTOM} sx={{ px: 2 }}>
          Custom
        </ToggleButton>
        {COMPETITOR_OFFERS_PRESETS.map((option) => (
          <Tooltip key={option.value} title={option.description}>
            <ToggleButton value={option.value} sx={{ px: 2 }}>
              {option.label}
            </ToggleButton>
          </Tooltip>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
}
